/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener('shopify:section:load', initLightbox);
  document.addEventListener('DOMContentLoaded', initLightbox);

  function initLightbox() {

    const triggers = document.querySelectorAll('.gallery-popup-trigger');
    const lightbox = document.getElementById('galleryLightbox');

    if (!lightbox || triggers.length === 0) return; // IMPORTANT

    const lightboxImg = lightbox.querySelector('.lightbox-image');
    const closeBtn = lightbox.querySelector('.lightbox-close');

    triggers.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        lightboxImg.src = this.href;
        lightbox.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', function(e){
      e.preventDefault();
      if (e.target === lightbox) {
        closeLightbox();
      }
    });

    function closeLightbox(){
      lightbox.style.display = 'none';
      lightboxImg.src = '';
      document.body.style.overflow = '';
    }
  }



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
